import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["alert"]
  static values = { key: String }

  connect() {
    // Check if already dismissed
    if (this.isDismissed()) {
      this.hide()
    }
  }

  dismiss() {
    this.saveDismissed()
    this.hide()
  }

  hide() {
    if (this.hasAlertTarget) {
      this.alertTarget.classList.add("hidden")
    }
  }

  isDismissed() {
    if (!this.hasKeyValue) return false
    return localStorage.getItem(`dismissed_${this.keyValue}`) === "true"
  }

  saveDismissed() {
    if (this.hasKeyValue) {
      localStorage.setItem(`dismissed_${this.keyValue}`, "true")
    }
  }
}
